import { Stack, Typography } from '@mui/material';
import { TSummaryMachineInfo } from '../../../../abelcommon/hooks/useMachineInfo';
import { FC } from 'react';
import { formatNumber } from '../../../../abelcommon';
import { useTranslation } from 'react-i18next';

interface IMachineListGeneralInfoProps {
  summaryMachineInfo: TSummaryMachineInfo;
}

export const MachineListGeneralInfo: FC<IMachineListGeneralInfoProps> = ({ summaryMachineInfo }) => {
  const { t } = useTranslation();
  return (
    <Stack sx={{ flexDirection: 'row', alignItems: 'center', gap: 2 }}>
      <Stack sx={{ flexDirection: 'row', gap: 1 }}>
        <Typography variant="body1" color="appGray.contrastText">
          {t('machineListGeneralInfo.totalHashRate')} (Mh/s):
        </Typography>
        <Typography variant="body1" color="success.main">
          {formatNumber(summaryMachineInfo.totalHashrate, { maximumFractionDigits: 2 })}
        </Typography>
      </Stack>
      <Stack sx={{ flexDirection: 'row', gap: 1 }}>
        <Typography variant="body1" color="appGray.contrastText">
          {t('machineListGeneralInfo.online')}:
        </Typography>
        <Typography variant="body1" color="success.main">
          {summaryMachineInfo.totalOnline}
        </Typography>
      </Stack>
      <Stack sx={{ flexDirection: 'row', gap: 1 }}>
        <Typography variant="body1" color="appGray.contrastText">
          {t('machineListGeneralInfo.offline')}:
        </Typography>
        <Typography variant="body1" color="appRed.main">
          {summaryMachineInfo.totalOffline}
        </Typography>
      </Stack>
    </Stack>
  );
};
